import { Typography } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { isReloadingForStaleChunk, reloadForStaleChunk } from 'utils/stale-chunk';
import style from './index.module.scss';

interface State {
  hasError: boolean;
  /** The tab is reloading into the current build after a stale-chunk error (G2-2). */
  reloading: boolean;
  error: Error | null;
  errorInfo: Error | null;
}

export class ErrorBoundary extends React.Component<PropsWithChildren<{}>, State> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false, reloading: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true, reloading: isReloadingForStaleChunk() };
  }

  componentDidCatch(error: any, errorInfo: any) {
    if (reloadForStaleChunk(error)) {
      this.setState({ reloading: true });
      return;
    }
    this.setState({ error: error, errorInfo: errorInfo });
  }

  render() {
    if (this.state.hasError) {
      if (this.state.reloading) {
        return null;
      }
      return (
        <div className={style.root}>
          <Typography variant={'h1'} color={'error'}>
            Something went wrong ;(
          </Typography>
          {this.state.error && (
            <Typography variant={'h2'} color={'error'}>
              {this.state.error.message}
            </Typography>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
